import React from 'react'
import { Grid } from 'react-bootstrap'
import polyglot from '../Translator'

export default function Privacy() {
  return (
    <div>
      <div style={{ textAlign: 'center', width: '100vw', fontSize: 30 }}>{polyglot.t('privacy_title')}</div>
      <Grid className="terms-privacy">
        <h3>{polyglot.t('privacy_document')}</h3>
      </Grid>
    </div>
  )
}
